import { createDateInBrazil } from "./dateUtils";

/**
 * Format a number as BRL currency for display.
 */
export const formatCurrency = (value: number): string =>
  (Number(value) ?? 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

/**
 * Format a date string for display (pt-BR). Returns "—" for null/empty.
 */
export const formatDate = (dateStr: string | null): string => {
  if (!dateStr) return "—";
  try {
    const d = createDateInBrazil(dateStr);
    return d.toLocaleDateString("pt-BR");
  } catch {
    return dateStr;
  }
};

/**
 * Format a date string as "Month, Year" (pt-BR). Returns "—" for null/empty.
 */
export const formatMonthYear = (dateStr: string | null): string => {
  if (!dateStr) return "—";
  try {
    const d = createDateInBrazil(dateStr);
    const month = d.toLocaleDateString("pt-BR", { month: "long" });
    const year = d.toLocaleDateString("pt-BR", { year: "numeric" });
    const monthCapitalized = month.charAt(0).toUpperCase() + month.slice(1);
    return `${monthCapitalized}, ${year}`;
  } catch {
    return dateStr;
  }
};
